import styled from "styled-components";
import { Style } from "../../styles";

const SimplebarContainer = styled.div`
  border: 1px solid ${Style.color.border};
  border-radius: 10px;
  overflow: hidden;
`

export default SimplebarContainer